import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 7.34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.78.228a.8.8 0 0 1 0 1.1l-5.5 5.778a.73.73 0 0 1-1.06 0l-3-3.112a.8.8 0 0 1 0-1.1.73.73 0 0 1 1.06 0l2.47 2.562L8.72.228a.73.73 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }